import { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import Select, { components } from 'react-select';
import 'react-tabs/style/react-tabs.css';
import moment from 'moment/moment.js';
import { NumericFormat } from 'react-number-format';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CreatableSelect from 'react-select/creatable';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/id';

import Switch from "react-switch";
import { isEmpty, numericValue } from "../../helper/helper.js"


function ShipmentForm({ props = { uid: null } }) {

	const [shipment, setShipment] = useState({
		shipmentDate: moment().format('YYYY-MM-DD'),
		externalTrackingNo: '',
		statusId: 0,
		histories: []
	});
	const [formData, setFormData] = useState({});
	const [jsonAttributes, setJSONAttributes] = useState({});

	const handleOnChangeInputText = (e) => {
		const { name, value } = e.target
		setShipment(prevState => ({
			...prevState,
			[name]: value
		}))
	}

	const calculateVolume = () => {
		return ((numericValue(shipment?.packageLength) * numericValue(shipment?.packageWidth) * numericValue(shipment?.packageHeight)) / 1000000)
	}

	const calculateChargeableWeight = () => {
		const volumeWeight = (numericValue(shipment?.packageLength) * numericValue(shipment?.packageWidth) * numericValue(shipment?.packageHeight)) / 4000;
		return volumeWeight > shipment?.packageWeight ? volumeWeight : shipment?.packageWeight;
	}

	const handleOnChangeSelect = (option, e) => {
		if (option) {
			if (e.action === "select-option") {
				setShipment(prevState => ({
					...prevState,
					[e.name]: option.value,
				}))
			} else {
				setShipment(prevState => ({
					...prevState,
					[e.name]: '',
				}))
			}
		}
	}

	const onChangeJsonFormat = async (e) => {
		setJSONAttributes(prevState => ({
			...prevState,
			jsonIsValid: (e.jsObject === undefined) ? false : true,
			jsonValue: e.jsObject ?? {}
		}))

		if (e.error === false) {
			setShipment(prevState => ({
				...prevState,
				attributes: jsonAttributes.jsonValue ?? {}
			}))
		}

	}

	const handleOnChangeSwitch = async (c, e, id) => {
		setShipment(prevState => ({ ...prevState, [id]: c }))
	}

	const onChangeShipperCode = async (option, e) => {
		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				shipperCode: option.value,
				shipperName: option.label
			}))

			await axios.post(`${window.API_HOST}/ui/v1/form/shipper`, {
				uid: option.uid
			}).then(async (res) => {
				setShipment(prevState => ({
					...prevState,
					shipperAddress: res.data.shipper.acc_address,
					shipperProvince: res.data.shipper.acc_province,
					shipperProvinceName: res.data.shipper.acc_province_name,
					shipperCity: res.data.shipper.acc_city,
					shipperCityName: res.data.shipper.acc_city_name,
					shipperDistrict: res.data.shipper.acc_district,
					shipperDistrictName: res.data.shipper.acc_district_name,
					shipperSubDistrict: res.data.shipper.acc_district,
					shipperSubDistrictName: res.data.shipper.acc_district_name,
					shipperPostalCode: res.data.shipper.postalcode,
					shipperEmail: res.data.shipper.acc_email,
					shipperPhone: res.data.shipper.acc_phone

				}))

				onChangeShipperProvince({ value: res.data.shipper.acc_province, label: res.data.shipper.acc_province_name }, { action: "select-option" })
				onChangeShipperCity({ value: res.data.shipper.acc_city, label: res.data.shipper.acc_city_name }, { action: "select-option" })
				onChangeShipperDistrict({ value: res.data.shipper.acc_district, label: res.data.shipper.acc_district_name }, { action: "select-option" })
				onChangeShipperSubDistrict({ value: res.data.shipper.acc_subdistrict, label: res.data.shipper.acc_subdistrict_name, postalcode: res.data.shipper.acc_postalcode }, { action: "select-option" })


			}).catch(err => {
			})

		} else if (e.action === "clear") {

		}
	}

	const onChangeShipperProvince = async (option, e) => {
		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				shipperProvince: option.value,
				shipperProvinceName: option.label,
				shipperCity: '',
				shipperCityName: '',
				shipperDistrict: '',
				shipperDistrictName: '',
				shipperSubDistrict: '',
				shipperSubDistrictName: '',
				shipperPostalCode: ''
			}))

			await axios.get(`${window.API_HOST}/ui/v1/form/city`, {
				params: { prov_code: option.value }
			}).then(async (res) => {
				const resp = res.data
				const cities = resp.data.city;
				setFormData(prevState => ({ ...prevState, mShipperCities: cities, mShipperDistricts: [], mShipperSubDistricts: [] }))
			}).catch(err => {
			})
		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				shipperProvince: '',
				shipperProvinceName: '',
				shipperCity: '',
				shipperCityName: '',
				shipperDistrict: '',
				shipperDistrictName: '',
				shipperSubDistrict: '',
				shipperSubDistrictName: '',
				shipperPostalCode: ''
			}))

			setFormData(prevState => ({
				...prevState,
				mShipperCities: [],
				mShipperDistricts: [],
				mShipperSubDistricts: []
			}))
		}
	}

	const onChangeShipperCity = async (option, e) => {

		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				shipperCity: option.value,
				shipperCityName: option.label,
				shipperDistrict: '',
				shipperDistrictName: '',
				shipperSubDistrict: '',
				shipperSubDistrictName: '',
				shipperPostalCode: ''
			}))
			await axios.get(`${window.API_HOST}/ui/v1/form/district`, {
				params: { city_code: option.value },
			}).then(res => {
				const resp = res.data
				const districts = resp?.data?.district;
				setFormData(prevState => ({ ...prevState, mShipperDistricts: districts ?? [], mShipperSubDistricts: [] }))
			}).catch(err => {
			})

		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				shipperCity: '',
				shipperCityName: '',
				shipperDistrict: '',
				shipperDistrictName: '',
				shipperSubDistrict: '',
				shipperSubDistrictName: '',
				shipperPostalCode: ''
			}))

			setFormData(prevState => ({
				...prevState,
				mShipperDistricts: [],
				mShipperSubDistricts: []
			}))
		}
	}

	const onChangeShipperDistrict = async (option, e) => {
		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				shipperDistrict: option.value,
				shipperDistrictName: option.label,
				shipperSubDistrict: '',
				shipperSubDistrictName: '',
				shipperPostalCode: ''
			}))

			await axios.get(`${window.API_HOST}/ui/v1/form/subdistrict`, {
				params: { district_code: option.value },
			}).then(res => {
				const resp = res.data
				const subdistricts = resp.data.subdistrict;
				setFormData(prevState => ({ ...prevState, mShipperSubDistricts: subdistricts ?? [] }))
			}).catch(err => {
			})

		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				shipperDistrict: '',
				shipperDistrictName: '',
				shipperSubDistrict: '',
				shipperSubDistrictName: '',
				shipperPostalCode: ''
			}))

			setFormData(prevState => ({
				...prevState,
				mShipperSubDistrict: []
			}))
		}
	}

	const onChangeShipperSubDistrict = async (option, e) => {
		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				shipperSubDistrict: option.value,
				shipperSubDistrictName: option.label,
				shipperPostalCode: option.postalcode
			}))

		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				shipperSubDistrict: '',
				shipperSubDistrictName: '',
				shipperPostalCode: ''
			}))
		}
	}

	const onChangeConsigneeProvince = async (option, e) => {
		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				consigneeProvince: option.value,
				consigneeProvinceName: option.label,
				consigneeCity: '',
				consigneeCityName: '',
				consigneeDistrict: '',
				consigneeDistrictName: '',
				consigneeSubDistrict: '',
				consigneeSubDistrictName: '',
				consigneePostalCode: ''
			}))

			await axios.get(`${window.API_HOST}/ui/v1/form/city`, {
				params: { prov_code: option.value }
			}).then(async (res) => {
				const resp = res.data
				const cities = resp.data.city ?? [];
				setFormData(prevState => ({ ...prevState, mConsigneeCities: cities, mConsigneeSubDistricts: [] }))
			}).catch(err => {
			})
		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				consigneeProvince: '',
				consigneeProvinceName: '',
				consigneeCity: '',
				consigneeCityName: '',
				consigneeDistrict: '',
				consigneeDistrictName: '',
				consigneeSubDistrict: '',
				consigneeSubDistrictName: '',
				consigneePostalCode: ''
			}))

			setFormData(prevState => ({
				...prevState,
				mConsigneeCities: [],
				mConsigneeDistricts: [],
				mConsigneeSubDistricts: [],

			}))
		}
	}

	const onChangeConsigneeCity = async (option, e) => {

		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				consigneeCity: option.value,
				consigneeCityName: option.label,
				consigneeDistrict: '',
				consigneeDistrictName: '',
				consigneeSubDistrict: '',
				consigneeSubDistrictName: '',
				consigneePostalCode: ''
			}))
			await axios.get(`${window.API_HOST}/ui/v1/form/district`, {
				params: { city_code: option.value },
			}).then(res => {
				const resp = res.data
				const districts = resp?.data.district ?? [];
				setFormData(prevState => ({ ...prevState, mConsigneeDistricts: districts, mConsigneeSubDistricts: [] }))
			}).catch(err => {
			})

		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				consigneeCity: '',
				consigneeCityName: '',
				consigneeDistrict: '',
				consigneeDistrictName: '',
				consigneeSubDistrict: '',
				consigneeSubDistrictName: '',
				consigneePostalCode: ''
			}))

			setFormData(prevState => ({
				...prevState,
				mConsigneeDistricts: [],
				mConsigneeSubDistricts: []
			}))
		}
	}

	const onChangeConsigneeDistrict = async (option, e) => {
		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				consigneeDistrict: option.value,
				consigneeDistrictName: option.label,
				consigneeSubDistrict: '',
				consigneeSubDistrictName: '',
				consigneePostalCode: ''
			}))

			await axios.get(`${window.API_HOST}/ui/v1/form/subdistrict`, {
				params: { district_code: option.value },
			}).then(res => {
				const resp = res.data
				const subdistricts = resp.data.subdistrict ?? [];
				setFormData(prevState => ({ ...prevState, mConsigneeSubDistricts: subdistricts }))
			}).catch(err => {
			})

		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				consigneeDistrict: '',
				consigneeDistrictName: '',
				consigneeSubDistrict: '',
				consigneeSubDistrictName: '',
				consigneePostalCode: ''
			}))


		}
	}

	const onChangeConsigneeSubDistrict = async (option, e) => {
		if (e.action === "select-option") {
			setShipment(prevState => ({
				...prevState,
				consigneeSubDistrict: option.value,
				consigneeSubDistrictName: option.label,
				consigneePostalCode: option.postalcode
			}))

		} else if (e.action === "clear") {
			setShipment(prevState => ({
				...prevState,
				consigneeSubDistrict: '',
				consigneeSubDistrictName: '',
				consigneePostalCode: ''
			}))
		}
	}

	// Custom Option component for the dropdown menu
	const CustomOption = (props) => {
		return (
			<components.Option {...props}>
				<div>{props.data.label} - <span className='fw-bold fs-6'>{props.data.postalcode}</span></div>
			</components.Option>
		);
	};


	const saveAction = async (e, isConfirmed) => {
		e.preventDefault()

		if (shipment.statusId >= 110) {
			toast.error(`shipment ${shipment.shipmentNum} has been confirmed and cannot be edited`)
			return
		}

		let payload = {
			shipment_no: shipment.shipmentNum ?? '',
			shipment_date: shipment.shipmentDate ?? '',
			reference_no: shipment.shipmentReference ?? shipment.shipmentNum ?? '',
			service_type: shipment.serviceType ?? '',
			account: shipment.shipperCode,
			courier_code: shipment.courierCode ?? '',
			shipper: {
				name: shipment.shipperName ?? '',
				address: shipment.shipperAddress ?? '',
				province: shipment.shipperProvinceName ?? '',
				city: shipment.shipperCityName ?? '',
				district: shipment.shipperDistrictName ?? '',
				subdistrict: shipment.shipperSubDistrictName ?? '',
				postalcode: shipment.shipperPostalCode ?? '',
				phone: shipment.shipperPhone ?? '',
				email: shipment.shipperEmail ?? '',
			},
			receiver: {
				name: shipment.consigneeName,
				address: shipment.consigneeAddress,
				province: shipment.consigneeProvinceName ?? '',
				city: shipment.consigneeCityName ?? '',
				district: shipment.consigneeDistrictName ?? '',
				subdistrict: shipment.consigneeSubDistrictName ?? '',
				postalcode: shipment.consigneePostalCode ?? '',
				phone: shipment.consigneePhone ?? '',
				email: shipment.consigneeEmail ?? '',

			},
			pickup: {
				name: shipment.shipperName ?? '',
				address: shipment.shipperAddress ?? '',
				province: shipment.shipperProvinceName ?? '',
				city: shipment.shipperCityName ?? '',
				district: shipment.shipperDistrictName ?? '',
				subdistrict: shipment.shipperSubDistrictName ?? '',
				postalcode: shipment.shipperPostalCode ?? '',
				phone: shipment.shipperPhone ?? '',
				email: shipment.shipperEmail ?? '',
			},
			package: {
				type: shipment.packageType ?? '',
				description: shipment.packageDescr ?? '',
				value: numericValue(shipment.packageValue) ?? 10000,
				weight: shipment.packageWeight ?? 1,
				quantity: 1,
				dimension: {
					length: shipment.packageLength ?? 10,
					width: shipment.packageWidth ?? 10,
					height: shipment.packageHeight ?? 10,
				}
			},
			delivery_instruction: shipment.deliveryInstruction ?? '',
			cod: shipment.isCod ?? false,
			insurance: shipment.isInsurance ?? false,
			attributes: shipment?.attributes ?? {},
			isConfirmed: isConfirmed
		}



		if (isEmpty(shipment.shipmentNum)) {
			toast.error('Shipment Number is empty')
			return
		}

		if (isEmpty(shipment.shipmentDate)) {
			toast.error('Shipment Date is empty')
			return
		}

		if (isEmpty(shipment.serviceType)) { toast.error('Service Type is Empty'); return; }


		if (isEmpty(shipment.shipperName)) { toast.error('Shipper Name is Empty'); return; }
		if (isEmpty(shipment.shipperAddress)) { toast.error('Shipper Address is Empty'); return; }
		if (isEmpty(shipment.shipperProvinceName)) { toast.error('Shipper Province is Empty'); return; }
		if (isEmpty(shipment.shipperCityName)) { toast.error('Shipper City is Empty'); return; }
		if (isEmpty(shipment.shipperDistrictName)) { toast.error('Shipper District is Empty'); return; }
		if (isEmpty(shipment.shipperPostalCode)) { toast.error('Shipper Postal Code is Empty'); return; }


		if (isEmpty(shipment.consigneeName)) { toast.error('Consignee Name is Empty'); return; }
		if (isEmpty(shipment.consigneeAddress)) { toast.error('Consignee Address is Empty'); return; }
		if (isEmpty(shipment.consigneeProvinceName)) { toast.error('Consignee Province is Empty'); return; }
		if (isEmpty(shipment.consigneeCityName)) { toast.error('Consignee City is Empty'); return; }
		if (isEmpty(shipment.consigneeDistrictName)) { toast.error('Consignee District is Empty'); return; }
		if (isEmpty(shipment.consigneePostalCode)) { toast.error('Consignee Postal Code is Empty'); return; }
		if (isEmpty(shipment.consigneePhone)) { toast.error('Consignee Phone is Empty'); return; }

		if (isEmpty(shipment.packageType)) { toast.error('Package Type is Empty'); return; }
		if (isEmpty(shipment.packageWeight)) { toast.error('Weight minimum is 1 Kg'); return; }
		if (isEmpty(shipment.packageValue)) { toast.error('Package Value is empty '); return; }

		await axios.post(`${window.API_HOST}/v1/create-shipment`, payload).then(async (res) => {
			const resp = res.data

			if (resp.data.tracking_no) {
				setShipment(prevState => ({
					...prevState,
					externalTrackingNo: resp.data.tracking_no,
					statusId: resp.data.status_id,
					statusDescr: resp.data.status_descr
				}))

			}

			toast.success(resp.message ?? `Success Update Shipment`);

		}).catch(err => {
			const resp = err.response
			toast.error(resp?.data?.error)
		})
	}

	useEffect(() => {
		//load provinces 

		async function fetchForm() {
			await axios.get(`${window.API_HOST}/v1/shipment/form`)
				.then(res => {
					const resp = res.data
					setFormData({
						provinces: resp.data.province ?? [],
						mCouriers: resp.data.courier ?? [],
						mServiceType: resp.data.serviceType ?? [],
						mPackageType: resp.data.packageType ?? [],
						mStatuses: resp.data.statuses ?? [],
						mShippers: resp.data.account ?? [],
					})
				}).catch(err => {

				})
		}

		async function retriveShipment() {
			await axios.get(`${window.API_HOST}/v1/shipment/${props?.uid}`)
				.then(res => {
					const resp = res.data

					setShipment(prevState => ({
						...prevState,
						shipmentNum: resp.data.shipment_no,
						shipmentReference: resp.data.shipment_reference,
						shipmentDate: resp.data.shipment_date,
						courierCode: resp.data.courier_code,
						serviceType: resp.data.service_type,

						shipperCode: resp.data.account,
						shipperName: resp.data.shipper.name,
						shipperAddress: resp.data.shipper?.address,
						shipperProvince: resp.data.shipper?.province,
						shipperProvinceName: resp.data.shipper?.province_name,
						shipperCity: resp.data.shipper?.city,
						shipperPostalCode: resp.data.shipper?.postalcode,
						shipperPhone: resp.data.shipper?.phone,
						shipperEmail: resp.data.shipper?.email,

						consigneeName: resp.data.receiver?.name,
						consigneeAddress: resp.data.receiver?.address,
						consigneeProvince: resp.data.receiver?.province,
						consigneePostalCode: resp.data.receiver?.postalcode,
						consigneePhone: resp.data.receiver?.phone,
						consigneeEmail: resp.data.receiver?.email,

						packageType: resp.data.package?.type,
						packageDescr: resp.data.package?.description,
						packageLength: resp.data.package?.dimension?.length,
						packageWidth: resp.data.package?.dimension?.width,
						packageHeight: resp.data.package?.dimension.height,
						packageWeight: resp.data.package?.weight,
						packageValue: resp.data.package?.value,

						externalTrackingNo: resp?.data?.courier_tracking,
						internalTrackingNo: resp?.data?.internal_tracking,

						deliveryInstruction: resp.data.delivery_instruction,

						isCod: resp.data.cod,
						attributes: resp.data.attributes,
						statusId: resp.data?.status_id ?? 0,
						statusDescr: resp.data.status_descr,
						histories: resp.data.histories ?? []

					}))

					onChangeShipperProvince({ value: resp.data.shipper.province, label: resp.data.shipper.province_name }, { action: "select-option" })
					onChangeShipperCity({ value: resp.data.shipper.city, label: resp.data.shipper.city_name }, { action: "select-option" })
					onChangeShipperDistrict({ value: resp.data.shipper.district, label: resp.data.shipper.district_name }, { action: "select-option" })
					onChangeShipperSubDistrict({ value: resp.data.shipper.subdistrict, label: resp.data.shipper.subdistrict_name, postalcode: resp.data.shipper.postalcode }, { action: "select-option" })

					onChangeConsigneeProvince({ value: resp.data.receiver.province, label: resp.data.receiver.province_name }, { action: "select-option" })
					onChangeConsigneeCity({ value: resp.data.receiver.city, label: resp.data.receiver.city_name }, { action: "select-option" })
					onChangeConsigneeDistrict({ value: resp.data.receiver.district, label: resp.data.receiver.district_name }, { action: "select-option" })
					onChangeConsigneeSubDistrict({ value: resp.data.receiver.subdistrict, label: resp.data.receiver.subdistrict_name, postalcode: resp.data.receiver.postalcode }, { action: "select-option" })

				}).catch(err => {

				})
		}

		fetchForm()

		if (!isEmpty(props?.uid)) {
			retriveShipment()
		}

	}, [props?.uid])

	return (
		<div>
			{/* <ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/home">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/shipment">Shipment</Link></li>
			</ol>
			<h1 className="page-header">New Shipment <small>{shipment?.shipmentNum ?? 90009002} - Status {uid}</small></h1> */}
			<Panel >
				<PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
					<div className='row'>
						<div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update Shipment' : 'Create Shipment'}</div>
						<div className='col-sm-6 align-items-baseline text-end'>
							<div className=''>
								<div className="btn-group me-1 mb-1">
									<a href="#/" className="btn btn-default" onClick={(e) => { saveAction(e, false) }}><i className='fa fa-save'></i> Save</a>
									<a href="#/" data-bs-toggle="dropdown" className="btn btn-default dropdown-toggle"><i className="fa fa-caret-down"></i></a>
									<div className="dropdown-menu dropdown-menu-end">
										<a href="#/" name="btnConfirm" className="dropdown-item" onClick={(e) => { saveAction(e, true) }} ><i className='fa fa-save'></i> Confirm</a>
									</div>
								</div>
								{(true) ? <button className="btn btn-sm btn-green ms-3 f-s-11 text-center ml-3" onClick={() => { }}><i className="fa fa-print"></i> Print</button> : null}
								{/* <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center m-auto" onClick={() => { }}><i className="fa fa-minus-circle"></i> Cancel</button>  */}
							</div>

						</div>
					</div>
				</PanelHeader>
				<PanelBody>
					<div className='row mb-2 p-0'>

						<div className="row m-0 p-0">
							<div className="col-sm-6 m-0 p-0">
								<div className="row" >
									<div className="col-sm-6 pl-3" style={{}}>
										<div className="form-group row mb-1">
											<label className="col-sm-5 col-form-label">Shipment Date</label>
											<div className="col-sm-7">
												<input type="date" name="shipmentDate" className="form-control form-control-sm" value={shipment?.shipmentDate ?? moment()} onChange={handleOnChangeInputText} disabled={props?.uid}/>
											</div>
										</div>
										<div className="form-group row mb-1">
											<label className="col-sm-5 col-form-label">Shipment No</label>
											<div className="col-sm-7">
												<input type="text" name="shipmentNum" className="form-control form-control-sm text-red" placeholder="Shipment No" value={shipment?.shipmentNum ?? ''} onChange={handleOnChangeInputText} disabled={props?.uid} />
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="form-group row mb-1">
											<label className="col-sm-5 col-form-label">Courier</label>
											<div className="col-sm-7">
												<Select name="courierCode" placeholder={"Courier"} className=''
													value={(formData?.mCouriers ?? []).find(({ value }) => { return value === shipment?.courierCode })}
													onChange={handleOnChangeSelect}
													options={formData?.mCouriers ?? []}
													isDisabled={(parseInt(shipment?.shipmentStatus) > 100)}
												/>
											</div>
										</div>
										<div className="form-group row mb-1">
											<label className="col-sm-5 col-form-label">Service Type</label>
											<div className="col-sm-7">
												<Select name="serviceType" placeholder={"Service Type"}
													value={(formData?.mServiceType ?? []).find(({ value }) => { return value === shipment?.serviceType })}
													onChange={handleOnChangeSelect} options={formData?.mServiceType}
													isDisabled={(parseInt(shipment?.shipmentStatus) > 100)} />
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-sm-3">
								<div className="row">
									<div className="col-sm-12">
										<div className="form-group row mb-1">
											<label className="col-sm-4 col-form-label">Ext. Tracking No</label>
											<div className="col-sm-8">
												<input type="text" className="form-control form-control-sm bg-gray-200 text-red" value={shipment?.externalTrackingNo ?? ''} disabled={true} />
											</div>
										</div>
									</div>
									<div className="col-sm-12">
										<div className="form-group row mb-1">
											<label className="col-sm-4 col-form-label">Status</label>
											<div className="col-sm-8">
												<input type="text" className="form-control form-control-sm bg-gray-200" value={`${shipment?.statusId} - ${shipment?.statusDescr}`} disabled={true} />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<div className="row">
						<div className='col-sm-8'>
							<div className='row'>
								<div className='col-sm-6 pt-2'>
									<div className="form-group row pb-1">
										<label className="col-sm-3 col-form-label">Shipper</label>
										<div className="col-sm-7">
											<Select name="shipperProvince" placeholder={"Shipper"}
												value={((formData?.mShippers ?? []).filter(({ value }) => { return value === shipment?.shipperCode; }))}
												options={formData?.mShippers ?? []}
												onChange={onChangeShipperCode}
												isClearable={false} isSearchable={true} isDisabled={(parseInt(shipment?.shipmentStatus) > 100)}
											/>
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-12">
											<input type="text" name="shipperName" className="form-control form-control-sm" placeholder="Shipper Name" onChange={handleOnChangeInputText} value={shipment?.shipperName ?? ''} />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-12">
											<textarea name="shipperAddress" className='form-control form-control-sm f-s-11' placeholder="Shipper Address" onChange={handleOnChangeInputText} value={shipment?.shipperAddress ?? ''}></textarea>
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<Select name="shipperProvince" placeholder={"Province"}
												value={((formData?.provinces ?? []).filter(({ value }) => { return value === shipment?.shipperProvince; }))}
												options={formData?.provinces ?? []}
												onChange={onChangeShipperProvince}
												isClearable={true} isSearchable={true} />
										</div>
										<div className="col-sm-6">
											<Select name="shipperCity" placeholder={"City"}
												value={((formData?.mShipperCities ?? []).filter(({ value }) => { return value === shipment?.shipperCity; }))}
												options={formData?.mShipperCities ?? []}
												onChange={onChangeShipperCity}
												isClearable={true} isSearchable={true} />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<Select name="shipperDistrict" placeholder={"District"}
												value={((formData?.mShipperDistricts ?? []).filter(({ value }) => { return value === shipment?.shipperDistrict; }))}
												options={formData?.mShipperDistricts}
												onChange={onChangeShipperDistrict}
												isClearable={true} isSearchable={true}
											/>
										</div>
										<div className="col-sm-6">
											<Select name="shipperSubDistrict" placeholder={"Sub District"}
												value={((formData?.mShipperSubDistricts ?? []).filter(({ value }) => { return value === shipment?.shipperSubDistrict; }))}
												options={formData?.mShipperSubDistricts}
												onChange={onChangeShipperSubDistrict}
												components={{ Option: CustomOption }}
												isClearable={true} isSearchable={true} />

										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<input type="text" name="shipperPostalCode" className="form-control form-control-sm" placeholder="Shipper Postal Code" value={shipment?.shipperPostalCode ?? ''} onChange={handleOnChangeInputText} />
										</div>
										<div className="col-sm-6">
											<input type="text" value={shipment?.originHub ?? ""} className="form-control form-control-md bg-grey-transparent-1" readOnly disabled />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<input type="text" name="shipperPhone" className="form-control form-control-sm" placeholder="Shipper Phone" value={shipment?.shipperPhone ?? ''} onChange={handleOnChangeInputText} />
										</div>
										<div className="col-sm-6">
											<input type="email" name="shipperEmail" className="form-control form-control-sm" placeholder="Shipper Email" value={shipment?.shipperEmail ?? ''} onChange={handleOnChangeInputText} />
										</div>
									</div>
								</div>

								<div className='col-sm-6 bg-grey-transparent-3 pt-2'>
									<div className="form-group row pb-2">
										<label className="col-sm-3 col-form-label">Consignee</label>
										<div className="col-sm-7">
											<input type="text" className="form-control form-control-sm" value={""} placeholder="" disabled={true} />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-12">
											<input type="text" name="consigneeName" className="form-control form-control-sm" placeholder="Consignee Name" value={shipment?.consigneeName} onChange={handleOnChangeInputText} />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-12">
											<textarea name="consigneeAddress" className='form-control form-control-sm' placeholder="Consignee Address" value={shipment?.consigneeAddress} onChange={handleOnChangeInputText}></textarea>
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<Select name="consigneeProvince" placeholder={"Province"}
												value={((formData?.provinces ?? []).filter(({ value }) => { return value === shipment?.consigneeProvince; }))}
												options={formData?.provinces}
												onChange={onChangeConsigneeProvince}
												isClearable={true} isSearchable={true} />
										</div>
										<div className="col-sm-6">
											<Select name="consigneeCity" placeholder={"City"}
												value={((formData?.mConsigneeCities ?? []).filter(({ value }) => { return value === shipment?.consigneeCity; }))}
												options={formData?.mConsigneeCities}
												onChange={onChangeConsigneeCity}
												isClearable={true} isSearchable={true} />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<Select name="consigneeDistrict" placeholder={"District"}
												value={((formData?.mConsigneeDistricts ?? []).filter(({ value }) => { return value === shipment?.consigneeDistrict; }))}
												options={formData?.mConsigneeDistricts}
												onChange={onChangeConsigneeDistrict}
												isClearable={true} isSearchable={true} />
										</div>
										<div className="col-sm-6">
											<Select name="consigneeSubDistrict" placeholder={"Sub District"}
												value={((formData?.mConsigneeSubDistricts ?? []).filter(({ value }) => { return value === shipment?.consigneeSubDistrict; }))}
												options={formData?.mConsigneeSubDistricts}
												onChange={onChangeConsigneeSubDistrict}
												components={{ Option: CustomOption }}
												isClearable={true} isSearchable={true} />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<input type="text" name="consigneePostalCode" className="form-control form-control-sm" placeholder="Consignee Postal Code" value={shipment?.consigneePostalCode} onChange={handleOnChangeInputText} />
										</div>
										<div className="col-sm-6">
											<input type="text" value={shipment?.destinationCode} className="form-control form-control-md bg-grey-transparent-1" readOnly disabled />
										</div>
									</div>
									<div className="form-group row mb-1">
										<div className="col-sm-6">
											<input type="text" name="consigneePhone" className="form-control form-control-sm" placeholder="Consignee Phone" value={shipment?.consigneePhone} onChange={handleOnChangeInputText} />
										</div>
										<div className="col-sm-6">
											<input type="text" name="consigneeEmail" className="form-control form-control-sm" placeholder="Consignee Email" value={shipment?.consigneeEmail} onChange={handleOnChangeInputText} />
										</div>
									</div>
								</div>

							</div>
							<div className='row mt-4'>
								<div className='col-sm-6'>
									<h5>Package Information</h5>
									<div className="form-group mb-1">
										<label className="mb-0 f-s-11">Package Type</label>
										<CreatableSelect name="packageType"
											placeholder={"Package Type"}
											isClearable
											options={formData?.mPackageType}
											value={(formData?.mPackageType ?? []).find(({ value }) => { return value === shipment?.packageType })}
											onChange={(e) => { setShipment(prevState => ({ ...prevState, packageType: e.value })) }}
										/>

									</div>

									<div className="row mb-0">
										<div className="form-group mb-1">
											<label className="mb-0 f-s-11">Package Description</label>
											<div className="input-group input-group-sm mb-10">
												<div className="input-group-prepend-sm col-sm-8 p-0">
													<input type="text" name="packageDescr" onChange={handleOnChangeInputText} value={shipment?.packageDescr}
														className="form-control form-control-sm" placeholder="" />
												</div>
												<input type="number" name="shipmentQtyCollies" value={shipment?.shipmentQtyCollies ?? 0}
													onChange={() => { }}
													className="form-control form-control-sm text-end" disabled={true} />
												<div className="input-group-append input-group-append-sm"><span className="input-group-text input-group-text-sm">COLLIE</span></div>
											</div>

											<div className="input-group input-group-sm mb-10">
											</div>
										</div>

										<div className="col-sm-3">
											<div className="form-group">
												<label className="mb-0 f-s-11">Length (cm)</label>
												<NumericFormat name="packageLength"
													value={shipment?.packageLength} thousandSeparator="," onChange={handleOnChangeInputText}
													allowNegative={false} decimalScale={0}
													className="form-control form-control-sm text-end" />
											</div>
										</div>
										<div className="col-sm-3">
											<div className="form-group">
												<label className="mb-0 f-s-11">Width (cm)</label>
												<NumericFormat name="packageWidth"
													value={shipment?.packageWidth} thousandSeparator="," onChange={handleOnChangeInputText}
													allowNegative={false} decimalScale={0}
													className="form-control form-control-sm text-end" />
											</div>
										</div>
										<div className="col-sm-3">
											<div className="form-group">
												<label className="mb-0 f-s-11">Height (cm)</label>
												<NumericFormat name="packageHeight"
													value={shipment?.packageHeight} thousandSeparator="," onChange={handleOnChangeInputText}
													allowNegative={false} decimalScale={0}
													className="form-control form-control-sm text-end" />
											</div>
										</div>
										<div className="col-sm-3">
											<div className="form-group">
												<label className="mb-0 f-s-11">Volume (m3)</label>
												<NumericFormat name="packageVolume"
													value={calculateVolume()} thousandSeparator="," allowNegative={false} decimalScale={3}
													className="form-control form-control-sm text-end" disabled={true} />
											</div>
										</div>
									</div>
									<div className="row mb-0">
										<div className="col-sm-6 mb-0">
											<div className="form-group">
												<label className="mb-0 f-s-11">Gross Weight (kg)</label>
												<NumericFormat name="packageWeight"
													value={shipment?.packageWeight} thousandSeparator="," onChange={handleOnChangeInputText}
													allowNegative={false} decimalScale={2} fixedDecimalScale
													isAllowed={(values) => {
														const { floatValue } = values;
														return floatValue <= 1000;
													}}
													className="form-control form-control-sm text-end" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="mb-0 f-s-11">Package Value</label>
												<NumericFormat name="packageValue"
													value={shipment?.packageValue} thousandSeparator="," onChange={handleOnChangeInputText}
													allowNegative={false} allowedDecimalSeparators={['%']} decimalScale={0}
													className="form-control form-control-sm text-end"
													isAllowed={(values) => {
														const { floatValue } = values;
														return floatValue <= 100000000;
													}}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className='col-sm-6'>
									<div className="row my-0 py-0">
										<div className="row">
											<div className="col-sm-4 mb-0">
												<div className="form-group mb-0">
													<label className="mb-0 f-s-11">COD</label>
													<div className="input-group input-group-sm mb-10">
														<div className="input-group mb-10">
															<Switch id="isCod" onChange={handleOnChangeSwitch} checked={shipment?.isCod ?? false} />
														</div>
													</div>
												</div>
											</div>
											<div className="col-sm-4 mb-0">
												<div className="form-group mb-0">
													<label className="mb-0 f-s-11">Insurance</label>
													<div className="input-group input-group-sm mb-10">
														<div className="input-group mb-10">
															<Switch id="isInsurance" onChange={handleOnChangeSwitch} checked={shipment?.isInsurance ?? false} />
														</div>
													</div>
												</div>
											</div>
											<div className="col-sm-4 mb-0">
												<div className="form-group mb-0">
													<label className="mb-0 f-s-11">Repacking</label>
													<div className="input-group input-group-sm mb-10">
														<div className="input-group mb-10">
															<Switch id="isRepacking" onChange={handleOnChangeSwitch} checked={shipment?.isRepacking ?? false} />
														</div>
													</div>
												</div>
											</div>

											<div className="form-group mb-1">
												<label className="mb-0 f-s-11">Delivery Instruction</label>
												<div className="input-group input-group-sm mb-10">
													<textarea name="deliveryInstruction" onChange={handleOnChangeInputText} value={shipment?.deliveryInstruction ?? ""}
														className='form-control form-control-sm' placeholder="Delivery Instruction"></textarea>
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>

						<div className='col-sm-4'>
							<div className="row">
								<div className='col-sm-12'>
									<Tabs>
										<TabList>
											<Tab>Delivery Cost</Tab>
											<Tab>History</Tab>
											<Tab>System References</Tab>
											<Tab>Attributes</Tab>
										</TabList>
										<TabPanel>
											<div className='row overflow-scroll h-600px m-0 p-0 '>
												<div className='col-sm-12 m-o p-0'>
													<table className="table table-hover table-responsive">
														<thead>
															<tr>
																<th>Item</th>
																<th className='text-end'>Amount</th>
															</tr>
														</thead>
														<tbody>
															<tr>
																<td><span className="f-s-11"> Chargeable Weight</span></td>
																<td className="with-input-control m-0 p-1">
																	<div className="input-group input-group-sm">
																		<div className="input-group-prepend">
																			<span className="input-group-text">Kg.</span>
																		</div>
																		<NumericFormat name="chargeableWeight"
																			value={calculateChargeableWeight()} thousandSeparator=","
																			decimalScale={2} disabled={true}
																			className="form-control form-control-sm text-end" ></NumericFormat>
																	</div>
																</td>
															</tr>
															<tr>
																<td><span className="f-s-11">Rate /Kg</span></td>
																<td className="with-input-control m-0 p-1">
																	<div className="input-group input-group-sm">
																		<div className="input-group input-group-sm">
																			<div className="input-group-prepend">
																				<span className="input-group-text">Rp.</span>
																			</div>
																			<NumericFormat name="ratePerKg"
																				value={shipment?.ratePerKg ?? 0} thousandSeparator=","
																				decimalScale={2} disabled={true}
																				className="form-control form-control-sm text-end" ></NumericFormat>
																		</div>
																	</div>
																</td>
															</tr>
															<tr className='table-info mt-5'>
																<td><span className="f-s-11"> Sub Total</span></td>
																<td className="with-input-control m-0 p-1">
																	<div className="input-group input-group-sm">
																		<div className="input-group input-group-sm">
																			<div className="input-group-prepend">
																				<span className="input-group-text">Rp.</span>
																			</div>
																			<NumericFormat name="packageValue"
																				value={0} thousandSeparator=","
																				decimalScale={2} disabled={true}
																				className="form-control form-control-sm text-end" ></NumericFormat>
																		</div>
																	</div>
																</td>
															</tr>
															<tr>
																<td className='with-checkbox'><span className="f-s-11">Insurance</span></td>
																<td className="with-input-control m-0 p-1">
																	<div className="input-group input-group-sm">
																		<div className="input-group input-group-sm">
																			<div className="input-group-prepend">
																				<span className="input-group-text">Rp.</span>
																			</div>
																			<NumericFormat name="chargeableWeight"
																				value={0} thousandSeparator=","
																				decimalScale={2} disabled={true}
																				className="form-control form-control-sm text-end" ></NumericFormat>
																		</div>
																	</div>
																</td>
															</tr>
															<tr>
																<td><span className="f-s-11">Repacking</span></td>
																<td className="with-input-control m-0 p-1">
																	<div className="input-group input-group-sm">
																		<div className="input-group input-group-sm">
																			<div className="input-group-prepend">
																				<span className="input-group-text">Rp.</span>
																			</div>
																			<input type="text" className="form-control form-control-sm text-end" value={""} disabled={true} />
																		</div>
																	</div>
																</td>
															</tr>
															<tr className="table-danger">
																<td><span className="f-s-15">Total</span></td>
																<td className="with-input-control m-0 p-1">
																	<div className="input-group input-group-sm">
																		<div className="input-group input-group-sm">
																			<div className="input-group-prepend">
																				<span className="input-group-text">Rp.</span>
																			</div>
																			<NumericFormat name="totalDeliveryCost"
																				value={0} thousandSeparator=","
																				decimalScale={2} disabled={true}
																				className="form-control form-control-lg text-end" ></NumericFormat>
																		</div>
																	</div>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>

										</TabPanel>
										<TabPanel>
											<div className='row overflow-scroll h-600px m-0 p-0 '>
												<div className='col-sm-12 m-0 p-0'>
													{shipment.histories.map((val, key) => {
														return (
															<div className="list-group list-group-flush rounded-bottom overflow-hidden p-0 " key={`milestone-${key}`}>
																<div className="list-group-item  d-flex border-top-0">
																	<div className="me-3 fs-16px">
																		<i className="far fa-check-circle text-success fa-fw"></i>
																	</div>
																	<div className="flex-fill">
																		<div className="fs-12px lh-12 mb-2px">
																			<span><i className='fa fa-calendar-days text-green'></i> <span className='fs-11px'>{val.status_date}</span></span>
																			<span className='ms-5'><i className='fa fa-user text-green'></i> <span className='fs-11px'>{val.created_by}</span></span>
																		</div>
																		<div className="fs-12px lh-12 mb-2px">
																			<span><span className='fs-11px'>{val.status_code} - {val.status_descr}</span></span>
																		</div>
																		{val.notes ? (
																			<div className="mb-1 fs-12px">
																				<div className="text-gray-600 flex-1"><i className='fa fa-comment text-green'></i> {val.notes}</div>
																			</div>) : ''}
																		<hr className="mb-10px bg-gray-600" />
																		<div className="d-flex align-items-center mb-5px">
																			{val.status_code === 'DELIVERED' ? (<div className="fs-11px text-dark">
																				Receiver: <strong>{val.receiver_name}</strong>
																			</div>) : ''}
																			{val.files && val.files.length > 0 ? (
																				<div className="ms-auto"> 
																					<button className='btn btn-outline-default text-gray-600 btn-xs rounded-pill fs-10px px-2' data-bs-toggle="collapse" data-bs-target={`#completedBoard${key}`}>images / document</button>
																				</div>
																			) : ''}
																		</div>
																		<div className="form-group mb-1">
																			<div className="collapse" id={`completedBoard${key}`}> 
																				{(Array.isArray(val.files) ? val.files : []).map(file => {
																					return (<>
																						<img src={file} className="rounded m-1" style={{ width: 50, height: 50, objectFit: 'cover' }} />  
																					</>)
																				})}
 

																			</div>
																		</div>
																	</div>
																</div>
															</div>
														)
													})}
													{/* </div> */}

												</div>

											</div>
										</TabPanel>
										<TabPanel>
											<div className='row overflow-scroll h-600px m-0 p-0 '>
												<div className='col-sm-12'>
													<div className="form-group row mb-1 top-0 align-top">
														<label className="col-sm-5 col-form-label">Internal Number</label>
														<div className="col-sm-7">
															<input type="text" name="internalNum" className="form-control form-control-sm" disabled={true} />
														</div>
													</div>
													<div className="form-group row mb-1 top-0 align-top">
														<label className="col-sm-5 col-form-label">Internal Tracking No</label>
														<div className="col-sm-7">
															<input type="text" name="internalNum" className="form-control form-control-sm" value={shipment?.internalTrackingNo ?? ''} disabled={true} />
														</div>
													</div>
													<div className="form-group row mb-1">
														<label className="col-sm-5 col-form-label">Shipment  Reference</label>
														<div className="col-sm-7">
															<input type="text" name="shipmentReference" className="form-control form-control-sm" value={shipment.shipmentReference ?? ''} onChange={handleOnChangeInputText} placeholder="" />
														</div>
													</div>
												</div>


											</div>
										</TabPanel>
										<TabPanel>
											<div className='row overflow-scroll h-600px m-0 p-0'>
												<div className='col-sm-12'>
													<JSONInput
														id='shipmentAttributes'
														name="shipmentAttributes"
														placeholder={shipment?.attributes ?? {}}
														value={shipment?.attributes ?? {}}
														onChange={onChangeJsonFormat}
														colors={{
															background: "rgba(182,194,201,.1)",
															default: "black",
															keys: "red"
														}}
														theme={"light_mitsuketa_tribute"}
														locale={locale}
														onKeyPressUpdate={true}
														waitAfterKeyPress={1300}
														width={'auto'}
													/>
												</div>
											</div>
										</TabPanel>
									</Tabs>
								</div>
							</div>

						</div>

					</div>
				</PanelBody>
			</Panel>
		</div>
	)
}

export default ShipmentForm;